import { Box, IconButton, Typography } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { GoodsReceiptPallet, WarehouseShelving } from "@/graphql/codegen/graphql"
import type { DestinationOverride } from "@/screens/WarehouseReceiving/components/GoodsReceiptPalletsTable/schemas/overrideDestinationSchema"
import { isPalletAs400SyncPending } from "@/screens/WarehouseReceiving/utils"

interface GoodsReceiptPalletDestinationCellProps {
  pallet: GoodsReceiptPallet
  destination?: DestinationOverride | WarehouseShelving | null
  shouldShowEdit?: boolean
  isEditDisabled?: boolean
  onOverride?: () => void
}

export const GoodsReceiptPalletDestinationCell: FC<GoodsReceiptPalletDestinationCellProps> = ({
  pallet,
  destination,
  shouldShowEdit = false,
  isEditDisabled = false,
  onOverride,
}) => {
  const handleStopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
  }

  if (pallet.goodsReceiptPalletRow?.unmanagedDestination) {
    return <Typography variant='body2'>{pallet.goodsReceiptPalletRow.unmanagedDestination}</Typography>
  }

  const resolvedDestination =
    destination || pallet.destinationWarehouseShelving || pallet.suggestedDestinationWarehouseShelving

  return (
    <Box onClick={handleStopPropagation}>
      <Box className='flex flex-col'>
        <Box className='flex items-center gap-1'>
          <Typography variant='h6' className='font-bold'>
            Aisle: {resolvedDestination?.aisleCode ?? "-"}
          </Typography>
          {shouldShowEdit && (
            <IconButton
              size='small'
              onClick={onOverride}
              disabled={isEditDisabled || isPalletAs400SyncPending(pallet)}
              data-testid='edit-destination-button'
            >
              <EditOutlined fontSize='small' />
            </IconButton>
          )}
        </Box>
        <Typography variant='subtitle2'>Shelf: {resolvedDestination?.sectionCode ?? "-"}</Typography>
        <Typography variant='subtitle2'>Bin: {resolvedDestination?.binNumber ?? "-"}</Typography>
      </Box>
    </Box>
  )
}
